<template>
  <b-card
    class="app-card"
    :class="{'grey-header': greyHeader, 'blue-header': blueHeader}"
  >
    <template class="app-card__header" v-if="showHeader" #header>
      <div class="d-flex justify-content-between align-content-center">
        <div class="app-card__header-left">
          <slot name="header-left"></slot>
        </div>
        <div class="app-card__header-right">
          <slot name="header-right"></slot>
        </div>
      </div>
    </template>
    <div>
      <slot name="text"></slot>
    </div>
    <div class="labels-block">
      <slot name="labels"></slot>
    </div>
    <template class="app-card__footer" v-if="showFooter" #footer>
      <div class="d-flex justify-content-between align-content-center">
        <div class="app-card__footer-left">
          <slot name="footer-left"></slot>
        </div>
        <div>
          <slot class="app-card__footer-right" name="footer-right"></slot>
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
export default {
  name: 'AppCard',
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    greyHeader: {
      type: Boolean,
      default: false
    },
    blueHeader: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.app-card.card {
  border-color: $text-color-gray-disabled;

  .card-header {
    border-top-right-radius: $border-m;
    border-top-left-radius: $border-m;
  }

  .card-footer {
    border-bottom-right-radius: $border-m;
    border-bottom-left-radius: $border-m;
  }

  &.active {
    border-color: $light-blue;
    box-shadow: 0 0 4px $shadow-color-primary;

    .card-header {
      border-bottom-color: $light-blue;
    }

    .card-footer {
      border-top-color: $light-blue;
    }
  }
}

.grey-header .card-header {
  background-color: $gray-200;
}

.blue-header .card-header {
  background-color: $background-primary;
}

.card-header, .card-footer {
  padding: 8px 10px;
  background-color: $white;
}

.card-header {
  font-size: 12px;
  border-bottom-color: $text-color-gray-disabled;
}

.card-footer {
  border-top-color: $text-color-gray-disabled;
}

.card-body {
  padding: 12px;
}
</style>
